import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheckIcon, CheckCircle2Icon, LockKeyholeIcon, ScaleIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <header className="border-b border-white/10" data-id="element-95">
      <section className="relative mx-auto max-w-6xl overflow-hidden px-5 pb-12 pt-7 text-center md:px-8 md:pb-16 md:pt-10" data-id="element-96">
        <div className="mx-auto mb-5 flex w-fit items-center gap-2 border border-accent/40 bg-accent/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-accent" data-id="element-97">
          <ScaleIcon size={15} aria-hidden="true" data-id="element-98" />
          Conversion Elite™
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} data-id="element-99">
          <h1 className="mx-auto max-w-4xl font-display text-4xl font-bold leading-[1.04] text-white md:text-6xl" data-id="element-100">
            Todo tu sistema de Modernización Laboral, listo para aplicar.
          </h1>
          <div className="mx-auto mt-6 max-w-md md:max-w-lg" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/61bqGvhyiwfYSd281VEfxT/f9c76881-29c8-453b-99d7-c39c0ec547fa.png" alt="Mockup del Tratado Práctico de Modernización Laboral 2026 y sus bonos" className="w-full drop-shadow-2xl" data-id="element-102" />
          </div>
          <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-stone-300 md:text-lg" data-id="element-103">
            Dejá de redactar escritos laborales desde cero. Una herramienta de
            trabajo desarrollada para profesionales que necesitan resolver casos
            con mayor rapidez, respaldo jurídico y seguridad profesional.
          </p>
        </motion.div>

        <motion.a href="#adquirir" whileHover={{
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className="mt-8 inline-flex items-center justify-center gap-2 bg-accent px-7 py-4 text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_rgba(183,142,69,0.2)] transition-colors hover:bg-[#d2ae6e] focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-ink md:text-base" data-id="element-104">
          Quiero mi tratado ahora
          <BookOpenCheckIcon size={19} aria-hidden="true" data-id="element-105" />
        </motion.a>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-stone-400 md:text-sm" data-id="element-106">
          <span className="inline-flex items-center gap-1.5" data-id="element-107">
            <CheckCircle2Icon size={15} className="text-accent" aria-hidden="true" data-id="element-108" />
            Acceso inmediato
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-109">
            <LockKeyholeIcon size={15} className="text-accent" aria-hidden="true" data-id="element-110" />
            Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-111">
            <ShieldCheckIcon size={15} className="text-accent" aria-hidden="true" data-id="element-112" />
            Garantía de 7 días
          </span>
        </div>
      </section>
    </header>;
}